import React, { useState, useEffect } from "react";
import { getCompetitors, Freshness } from "../data";
import { CompetitorBadge } from "../components/Shared";

export default function CompetitorList() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCompetitors().then((d) => {
      setData(d);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-400">Loading competitors...</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div>
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Competitors</h1>
        <div className="dashboard-card text-center py-12">
          <p className="text-gray-400 text-lg">Run data export to load competitor data</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h1 className="text-2xl font-bold text-gray-900">Competitors</h1>
        <span className="text-sm text-gray-500">{data.total} total</span>
      </div>
      <Freshness dateStr={data.last_updated} label="Config" />

      <div className="mt-6 space-y-8">
        {data.categories.map((section) => (
          <section key={section.name}>
            <h2 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
              {section.name}
              <span className="text-sm font-normal text-gray-400">
                ({section.competitors.length})
              </span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {section.competitors.map((comp) => (
                <CompetitorBadge
                  key={comp.name}
                  name={comp.name}
                  category={section.name}
                />
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
